<div class="sg-icon-container">
  <mat-icon class="sg-icon-background" [ngStyle]="backgroundIconStyle()">sg-icon-background</mat-icon>
  <ng-content></ng-content>
</div>
